import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'climb-auth-container',
  templateUrl: './auth-container.component.html',
  styleUrls: ['./auth-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthContainerComponent { }
